import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY h:mm A');
}

class TrainingActive extends React.Component {

    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null)
        this.state = {
            user: userExists ? props.location.state.user : {},
            upcomingData: historyExists ? props.history.location.state.data : [],
            upcomingLoading: false,
            completedData: historyExists ? props.history.location.state.data : [],
            completedLoading:false
        };

        this.handleTableChange = this.handleTableChange.bind(this);

        this.completedLoadingSpinner = this.completedLoadingSpinner.bind(this);
        this.upcomingLoadingSpinner = this.upcomingLoadingSpinner.bind(this);
        this.getUpcomingTrainings = this.getUpcomingTrainings.bind(this);
        this.getCompletedTrainings = this.getCompletedTrainings.bind(this);

    }

    componentDidMount() {
        this.handleTableChange("search", this.state);
    }

    completedLoadingSpinner() {
        if (this.state.completedLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'We don’t have any trainings on file for you yet. Register above or email us at marketing@boland.com with questions.';
        }
    };
    upcomingLoadingSpinner() {
        if (this.state.upcomingLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No upcoming trainings have been registered for.';
        }
    };

    getUpcomingTrainings() {
        axios.get(`${Constants.apiURL}/api/Training/GetUpcomingTraining`, {
            params: {
                user: this.state.user.username,
                email: this.state.user.email
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    upcomingData: response.data,
                    upcomingLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ upcomingLoading: false });
            console.log('request failed', response)
        });
    }

    getCompletedTrainings() {
        axios.get(`${Constants.apiURL}/api/Training/GetCompletedTraining`, {
            params: {
                user: this.state.user.username,
                email: this.state.user.email
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                this.setState(() => ({
                    completedData: response.data,
                    completedLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ completedLoading: false });
        });
    }

    handleTableChange = (type, { }) => {
        this.setState({
            upcomingLoading: true,
            upcomingData: [],
            completedLoading: true,
            completedData: []
        },
            function () {
                this.getUpcomingTrainings();
                this.getCompletedTrainings();
            });
    }

    render() {
        const completedColumns = [
            {
                text: 'Certificate',
                dataField: 'x',
                formatter: (cell, row) => {
                    return <Button style={{ backgroundColor: '#1F419B', width: '100%' }} onClick={(event) => {

                        axios.get(`${Constants.apiURL}/api/Training/DownloadCertificate`, {
                            params: {
                                user: this.state.user.username,
                                registrationID: row.Id
                            },
                            responseType: "blob"
                        }).then(response => {
                            this.setState({ loading: false });

                            ReactGA.event({
                                category: 'Download',
                                action: 'Training Certificate',
                                label: ''
                            });
                            let blob = new Blob([response.data], { type: "application/pdf" }),
                                downloadUrl = window.URL.createObjectURL(blob),
                                filename = "",
                                disposition = response.headers["content-disposition"];

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                                    matches = filenameRegex.exec(disposition);

                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, "");
                                }
                            }
                            else {
                                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                                return;
                            }

                            let a = document.createElement("a");
                            if (typeof a.download === "undefined") {
                                window.location.href = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }).catch((response) => {
                            // ? Show to user that request is failed
                            this.setState({ errors: [response] })
                            this.setState({ loading: false });
                            console.log('request failed', response)
                        });
                    }}>Download</Button>
                },
                headerStyle: (colum, colIndex) => {
                    return { width: '130px', textAlign: 'center' };
                }
            },
            {
                text: 'Name',
                dataField: 'Name',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', fontWeight:'bold' };
                },
                style: { fontWeight: 'bold' }
            },
            {
                text: 'Start',
                dataField: 'StartDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'End',
                dataField: 'EndDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Location',
                dataField: 'Location',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', wordBreak: 'break-all'  };
                }
            },
            {
                text: 'Instructor(s)',
                dataField: 'Instructors',
                headerStyle: (colum, colIndex) => {
                    return {
                        textAlign: 'center', width: '300px', wordBreak: 'break-all'
                    };
                }
            },
            {
                text: 'Learning Hours',
                dataField: 'LearningHours',
                headerStyle: (colum, colIndex) => {
                    return { width: '110px', textAlign: 'center' };
                }
            },
            {
                text: 'Survey Link',
                dataField: 'SurveyLink',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', wordBreak: 'break-all' };
                },
                formatter: (cell, row) => {
                    return <Form.Label as={Link} to={{ pathname: cell }} onClicn={() => {
                        ReactGA.event({
                            category: 'Training',
                            action: 'Survey Click',
                            label: ''
                        });
                    }} target="_blank">Survey</Form.Label>
                }
            },
            {
                text: 'Training Materials Link',
                dataField: 'TrainingMaterialsLink',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', wordBreak: 'break-all' };
                },
                formatter: (cell, row) => {
                    return <Form.Label as={Link} to={{ pathname: cell }} onClicn={() => {
                        ReactGA.event({
                            category: 'Training',
                            action: 'Materials Click',
                            label:''
                        });
                    }} target="_blank">Training Materials</Form.Label>
                }
            }];
        const upcomingColumns = [
            {
                text: 'Name',
                dataField: 'Name',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'250px' };
                },
                style: { fontWeight: 'bold' }
            },
            {
                text: 'Description',
                dataField: 'Description',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width: '250px' };
                }
            },
            {
                text: 'Start',
                dataField: 'StartDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'End',
                dataField: 'EndDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Location',
                dataField: 'Location',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', width:'250px', wordBreak: 'break-all' };
                }
            }];
        const { upcomingData, completedData } = this.state;


        const customStyle = {
            padding: '10px',
            margin: '10px',
            height:'500px'
        };
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='trainingMain' />
                <Form onSubmit={this.handleSearch}  className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>
                                My Upcoming Trainings</Form.Label>
                            <br />
                            <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>
                                Below is a list of training events for which you are registered. Please contact marketing@boland.com with questions on upcoming trainings.</Form.Label>
                        </Col>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="Id"
                    data={upcomingData}
                    columns={upcomingColumns}
                    wrapperClasses="training-top training-active-table"
                    //filter={filterFactory()}
                    striped
                    hover
                    noDataIndication={this.upcomingLoadingSpinner}
                    loading={this.state.upcomingLoading}
                    style={customStyle}
                    onTableChange={this.handleupcomingTableChange}
                />
                <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px' }}>
                    <Col md="auto" sm="auto" xs="auto">
                        <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>Trainings I've Attended</Form.Label><br />
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>Below are training events you have attended since October 2022. Please contact marketing@boland.com regarding events not listed below.</Form.Label>

                    </Col>
                </Form.Group>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="Id"
                    wrapperClasses="table-responsive training-complete-table"
                    data={completedData}
                    columns={completedColumns}
                    //filter={filterFactory()}
                    striped
                    hover
                    noDataIndication={this.completedLoadingSpinner}
                    loading={this.state.completedLoading}
                    style={customStyle}
                    onTableChange={this.handleCompletedTableChange}
                />
            </div>
        );
    }
}

export default TrainingActive;